export class CategoriesMenuItem {
    constructor(public id: number, public name: string) {}
}
